import { mfsError, Result } from '../../errors';
import { MfsItemId } from '../mfsTypes';
import { isValidLabelPropertyValue, LabelTracker } from './types';

/**
 * Determines whether a label + labelId of the current item is unique or already taken
 *
 * @param currentItemId The id of the item to check whether it can claim the given label + labelId.
 * @returns Error result, if the label + labelId are in use by another itemId; success result with undefined value, if
 *   the label+labelId are available, success result with the currentItemId if the label + labelId are already in use by
 *   the current item id.
 */
export function canUseLabelId(
  labelTracker: LabelTracker,
  label: string,
  labelId: string,
  currentItemId: MfsItemId
): Result<MfsItemId> {
  if (!isValidLabelPropertyValue(label)) {
    return Result.fail(mfsError.invalidLabel());
  }

  if (!isValidLabelPropertyValue(labelId)) {
    return Result.fail(mfsError.invalidLabelId());
  }

  const trackingItemId = labelTracker.getItemId(label, labelId);

  return !trackingItemId || trackingItemId === currentItemId
    ? Result.ok(trackingItemId)
    : Result.fail(mfsError.labelIdInUse(trackingItemId, label, labelId));
}
